module.exports = __webpack_public_path__ + "img/cog-white.9eb279d7.svg";